import React from 'react';
import Header from '../pages/util/Header'; 
import Footer from '../pages/util/Footer'; 

const MainLayout = ({ children }) => {
    return (
        <div id="main-wrapper">
            <Header />
            <div className="page-wrapper">
                <div className="container-fluid">
                    {children}
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default MainLayout;